import { render, staticRenderFns } from "./HomeArticleView.vue?vue&type=template&id=088f60c4"
import script from "./HomeArticleView.vue?vue&type=script&lang=js"
export * from "./HomeArticleView.vue?vue&type=script&lang=js"
import style0 from "./HomeArticleView.vue?vue&type=style&index=0&id=088f60c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports